// extracted by mini-css-extract-plugin
export default {"subsidiary":"Subsidiary_subsidiary__Q5A6I","subsidiary__inner":"Subsidiary_subsidiary__inner__bB3ga"};